import { render, staticRenderFns } from "./LookSale.vue?vue&type=template&id=3e23d8a6&scoped=true&"
import script from "./LookSale.vue?vue&type=script&lang=ts&"
export * from "./LookSale.vue?vue&type=script&lang=ts&"
import style0 from "./LookSale.vue?vue&type=style&index=0&id=3e23d8a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e23d8a6",
  null
  
)

export default component.exports